import { render, staticRenderFns } from "./DetailPromotion.vue?vue&type=template&id=214e0153&"
import script from "./DetailPromotion.vue?vue&type=script&lang=js&"
export * from "./DetailPromotion.vue?vue&type=script&lang=js&"
import style0 from "./DetailPromotion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports